<div>
	<h1 class="title">{{ title }}</h1>
	<div class="chart-with-legend">
		@if(!this.hasData){
		<div class="no-data">
			{{ Loc(LocalizedTextIds.StackedBarChartNoAssets) }}
		</div>
		}
		<div class="chart" [id]="id"></div>
		@if(this.hasData) {
		<div class="legend">
			<legend
				[items]="itemsForLegend"
				[title]="xAxisLabel"
				[itemLabel]="itemLabel"
			></legend>
		</div>
		}
	</div>
</div>
